module.exports = __webpack_public_path__ + "assets/544fe5f6d4f694b97b83895cf3c6feec.png";